import { TVariable } from "./store"

export function getInvalidPlaceholders(
	variables: Array<TVariable>,
	...contentWithPlaceholders: Array<string>
) {
	const invalidPlaceholders: Array<string> = []
	contentWithPlaceholders.forEach((content) => {
		if (!content) return
		// check for non-existing variable placeholders
		const placeholderRegex = /\{\{\s*([\w\d]+)\s*\}\}/gi
		let result
		while ((result = placeholderRegex.exec(content)) !== null) {
			const p = result[1]
			if (!variables.find((v) => v.placeholder === "{{" + p.trim() + "}}")) {
				invalidPlaceholders.push(p)
			}
		}
	})
	return invalidPlaceholders
}

function extractVariables(text: string): string[] {
	return text.match(/\{\{[^}]+\}\}/g) ?? []
}

export function validateVariables(
	value: string,
	allowedVariables: string[],
	context: string
): { field: string; message: string } | undefined {
	const usedVariables = extractVariables(value)

	const invalidVariables = usedVariables.filter(
		(v) => !allowedVariables.includes(v)
	)

	if (invalidVariables.length > 0) {
		return {
			field: context,
			message: `The placeholder variable(s) in the ${context.charAt(0).toUpperCase() + context.slice(1)} are invalid: ${invalidVariables.join(", ")}.`,
		}
	}

	return undefined
}
